<template>

<div class="buyer-basic-card">
  <img v-if="currentSession && currentSession.to_avatar" class="user-avatar" :src="default_img" :onload="loadImg(currentSession.to_avatar)" :onerror="error_img" >
  <div class="user-meta">
    <div class="user-title">
      <div class="user-nickname">
        <font style="vertical-align: inherit;">
          <font v-if="currentSession && currentSession.to_name" style="vertical-align: inherit;">{{currentSession.to_name}}</font></font>
      </div>
    </div>
    <div v-if="false" @click="follow()" class="user-follow">
      <span>
        <font style="vertical-align: inherit;">
          <font style="vertical-align: inherit;">邀请关注</font></font>
      </span>
    </div>
  </div>
  
  <div v-if="!buyerInfo.presale" @click="addSalesModalShow()" style="margin-left: 50px;font-size: 12px;cursor: pointer;">
    售前备注<Icon color="#0898ff" size="16" type="md-create" />
  </div>
  <div v-if="buyerInfo.presale" @click="editSalesModalShow()" style="margin-left: 50px;font-size: 12px;cursor: pointer;">
    <span style="font-weight: bold;">{{buyerInfo.presale.remark}}</span><Icon color="#0898ff" size="16" type="md-create" />
  </div>
  <div class="user-detail">
    <section style="display: none;">
      <dt>
        <font style="vertical-align: inherit;">
          <font style="vertical-align: inherit;">记录</font></font>
      </dt>
      <dd>
        <div class="user-note">
          <div class="note-edit">
            <div class="im-icon im-icon-pencil im-icon-xs">
              <svg width="15px" height="13px" viewBox="0 0 15 13" version="1.1">
                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g class="im-icon-pencil-stroke" transform="translate(-123.000000, -298.000000)">
                    <g transform="translate(36.000000, 84.000000)">
                      <g>
                        <g transform="translate(86.000000, 213.000000)">
                          <g transform="translate(-1.000000, -1.000000)">
                            <g transform="translate(7.646447, 7.646447) rotate(-315.000000) translate(-7.646447, -7.646447) translate(5.146447, 0.646447)">
                              <path d="M1.42073757,3.09398105 L4.42073757,3.09398105 L4.42073757,1.59398105 C4.42073757,1.31783868 4.19687995,1.09398105 3.92073757,1.09398105 L1.92073757,1.09398105 C1.6445952,1.09398105 1.42073757,1.31783868 1.42073757,1.59398105 L1.42073757,3.09398105 Z"></path>
                              <path d="M1.42073757,3.09398105 L1.42073757,11.4093763 L2.92073757,13.1638364 L4.42073757,11.4093763 L4.42073757,3.09398105 L1.42073757,3.09398105 Z"></path>
                            </g>
                            <line x1="2.52394497" y1="14.363961" x2="15.577466" y2="14.363961" stroke-linecap="round"></line>
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </svg>
            </div>
          </div>
        </div>
      </dd>
    </section>
  </div>
  <div class="user-section">
    
    <section v-if="currentSession">
      <dt>是否已读</dt>
      <dd>
        <span style="cursor: pointer;color: #0898ff;" @click="unreadSession" v-if="currentSession.unread_count == 0">标记为未读</span>
      </dd>
    </section>
    <section v-if="currentSession">
      <dt>重新分配</dt>
      <dd>
        <Select v-model="selectUserId" @on-change="transferCsr" filterable>
            <Option :disabled="item.status == 3 ? false : true" v-for="item in childUser" :value="item.id" :key="item.id">{{ item.username }}</Option>
        </Select>
      </dd>
    </section>
  </div>
  <div style="display: none;" class="user-operation">
    <div class="agent-assign-title">
      <button type="button" class="im-components-btn im-components-btn-secondary im-components-btn-small assign">
        <span>
          <font style="vertical-align: inherit;">
            <font style="vertical-align: inherit;">分配</font></font>
        </span>
      </button>
    </div>
    <button style="display: none;" type="button" class="im-components-btn im-components-btn-secondary im-components-btn-small btn-opr">
      <i class="im-components-icon im-components-icon-favorite im-components-icon-xs star-pinner unpinned"></i>
      <i class="im-components-icon im-components-icon-arrow-down im-components-icon-medium im-components-icon-last"></i>
    </button>
  </div>
  

<Modal 
  v-model="addPsalesModal"
  title="售前备注"
  :footer-hide="true"
  width="400"
  >
   <Form :model="salesForm" :label-width="80">
    <FormItem label="订单类型">
      <Select v-model="salesForm.type" style="width:200px">
            <Option value="1">常规</Option>
            <Option value="2">退款</Option>
            <Option value="3">紧急</Option>
            <Option value="4">补发</Option>
            <Option value="5">私下退换</Option>
        </Select>
    </FormItem>
    <FormItem label="备注">
      <Input v-model="salesForm.remark" type="textarea" :autosize="{minRows: 2,maxRows: 5}" placeholder="请输入备注"></Input>
    </FormItem>
    <FormItem>
        <Button @click="preSalesAdd()" type="primary">确定</Button>
    </FormItem>
  </Form>
</Modal>

<Modal 
  v-model="editPsalesModal"
  title="售前备注"
  :footer-hide="true"
  width="400"
  >
   <Form :model="editsalesForm" :label-width="80">
    <FormItem label="备注">
      <Input v-model="editsalesForm.remark" type="textarea" :autosize="{minRows: 2,maxRows: 5}" placeholder="请输入备注"></Input>
    </FormItem>
    <FormItem>
        <Button @click="preSalesEdit()" type="primary">确定</Button>
    </FormItem>
  </Form>
</Modal>

</div>

</template>
<script>
import conf from "../../conf";
import RequestUtils from "../../../../utils/RequestUtils";

export default {
  data() {
    return {
      default_img: require("../../../../static/img/default_avatar.png"),
      error_img: 'this.src="'+require("../../../../static/img/default_avatar.png")+'";',
      loadImg: (imgSrc) => {
        return 'this.onload=null;this.src='+'"'+imgSrc+'";';
      },
      buyerInfo: {},
      addPsalesModal: false,
      editPsalesModal: false,
      salesForm: {
        id: '',
        type: 1,
        remark: ''
      },
      editsalesForm: {
        id: '',
        remark: ''
      },
      selectUserId: 0

    };
  },
  created() {
  },
  computed: {
    currentSession: {
      get: function() {
        let shop_id = this.$store.state.shopee.currentStore.shop_id;
        return this.$store.state.shopee.currentSessionData[shop_id];
      }
    },
    childUser: {
      get: function () {
        return this.$store.state.childUser;
      }
    }
  },
  methods: {
    preSalesAdd() {
      this.addPsalesModal = false;
      let param = new FormData();
      param.set("store_id", this.$store.state.shopee.currentStore.id);
      param.set("connector", 'shopee');
      param.set("buyer_id", this.currentSession.to_id);
      param.set("buyer_username", this.currentSession.to_name);
      param.set("remark", this.salesForm.remark);
      param.set("type", this.salesForm.type);

      RequestUtils.request(conf.presalesAdd(), param).then(() => {
        this.salesForm.remark = '';
        this.salesForm.type = 1;        
        this.$Message.success('添加成功!');
        this.getBuyerInfo();
      })
    },
    preSalesEdit() {
      this.editPsalesModal = false;
      let param = new FormData();
      param.set("presale_id", this.buyerInfo.presale.id);
      param.set("remark", this.editsalesForm.remark);
      param.set("connector", 'shopee');

      RequestUtils.request(conf.presalesEdit(), param).then(() => {
        this.buyerInfo.presale.remark = this.editsalesForm.remark;
        this.editsalesForm.remark = '';
        this.$Message.success('修改成功!');
      })
    },
    addSalesModalShow() {
      this.addPsalesModal = true;
    },
    editSalesModalShow() {
      this.editPsalesModal = true;
      this.editsalesForm.id = this.buyerInfo.presale.id
      this.editsalesForm.remark = this.buyerInfo.presale.remark;
    },
    getBuyerInfo () {
      let param = new FormData();
      param.set("buyer_id", this.currentSession.to_id);
      param.set("store_id", this.$store.state.shopee.currentStore.id);
      param.set("connector", 'shopee');
      RequestUtils.request(conf.getBuyerInfo(), param).then(json => {
        this.buyerInfo = json;
      })
    },
    follow () {
      let self = this;
      let param = new FormData();
      param.set("store_id", this.$store.state.shopee.currentStore.id);
      param.set("session_id", this.currentSession.session_id);
      param.set("connector", 'shopee');
      param.set("template_id", 10010);
      RequestUtils.request(conf.sendMessage(), param).then(json => {
        console.log(json);
        let message = {
          message_id: json.message_id,
          template_id: 10010,
          data: {
            'title': JSON.stringify({'en': 'Follow the store'}),
            'iconUrl': self.$store.state.shopee.currentStore.logo_url,
            'desc': self.$store.state.shopee.currentStore.seller_name

          }
        };
        self.$store.commit("shopee/addMessage", message);
      })
    },
    // 转移客服
    transferCsr (user_id) {
      RequestUtils.webSocketSend('transferCsr', {
        'platform': 'shopee',
        'session_id': this.currentSession.id,
        'admin_id': user_id
      });
      this.selectUserId = 0;
      this.$store.commit("shopee/setCurrentSessionData", '');
    },
    // 标记会话为未读
    unreadSession() {
      let param = new FormData();
      param.set("id", this.currentSession.id);
      RequestUtils.request(conf.unreadCount(), param).then(json => {
        if (json) {
          this.$store.commit("shopee/setCurrentSessionData", json);
          this.$store.commit("shopee/setSessionDataBySid", json);
        }
      })
    },
  }
};
</script>
<style lang="scss">
@import "@/static/styles/theme";

.buyer-basic-card {
  word-break: break-word;
  background-color: #fff;
  padding: 12px 16px 16px;
  margin-bottom: 8px;
  position: relative;

  section {
    display: table-row;
    margin-top: 16px;
  }

  dt {
    color: #999;
    padding-right: 10px;
    text-align: right;
    white-space: nowrap;
    display: table-cell;
    padding-top: 12px;
  }

  .assign, .btn-opr {
    flex-grow: 1;
    justify-content: center;
    height: auto;
    line-height: 12px;
    padding: 7px;
    flex-basis: 30%;
    border-width: 1px;
  }

  .im-components-btn {
    border-radius: 4px;
    font-size: 13px;
    position: relative;
    display: inline-block;
    font-style: normal;
    font-family: inherit;
    background: transparent;
    cursor: pointer;
    text-align: center;
  }

  .im-components-btn-secondary {
    background-color: #fff;
    border-color: rgba(64,112,244,.5);
    color: #4070f4;
  }

  .user-avatar {
    width: 40px;
    height: 40px;
    border-radius: 100%;
    position: absolute;
    background-color: #faf6f0;
  }

  .user-meta {
    display: flex;
    align-items: center;
    margin-bottom: 6px;
    margin-left: 50px;

    .user-title {
      flex: 1 1;

      .user-nickname {
        display: inline-block;
        font-weight: 700;
      }
    }

    .user-follow {
      color: #4070f4;
      cursor: pointer;
    }
  }

  .user-detail {
    display: table;
    font-size: 12px;
    margin-top: 6px;
    margin-bottom: 20px;

  }

  .user-operation {
    display: flex;
    flex-direction: row;
    margin-right: -10px;
    font-size: 13px;

    .agent-assign-title {
      flex-grow: 1;
      flex-basis: 30%;
      margin-right: 10px;
      display: flex;
      align-items: center;
    }
  }

  .im-injector-assign-banner {
    color: #858b9c;
    background: #f2f3f7;
    margin: 16px -16px -16px;
    padding: 8px;
    border-radius: 0 0 12px 12px;
    font-size: 12px;
    text-align: center;
  }
}
</style>
